<div class="form-group">
    <label class="text-label" [attr.for]="id">{{ label }}</label>
    <input
      [type]="type"
      [id]="id"
      class="style-input"
      [placeholder]="placeholder"
      [formControl]="control"
    />
  </div>
  